export function getDatetimeDisplayString(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours() % 12 || 12).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = date.getHours() >= 12 ? 'pm' : 'am';
  return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
}

export function getDatetimeDisplayString24h(datetimeStr: string): string {
  const dateMatch = datetimeStr.match(/(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})/);
  if (!dateMatch) throw new Error('Invalid datetime format');
  const [year, month, day, hours, minutes] = dateMatch;
  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

export function getUtcDatetimeDisplayString(value?: string | null): string {
  if (!value) return '--';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleString(undefined, {
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    month: '2-digit',
    second: '2-digit',
    timeZone: 'UTC',
    year: 'numeric',
  });
}

export function getCdtDisplayString(dateValue: string): string {
  const trimmed = dateValue?.trim?.() ?? '';
  if (!trimmed) return '-';

  const date = new Date(trimmed);
  if (Number.isNaN(date.getTime())) return trimmed;

  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Chicago',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZoneName: 'short',
  });

  const parts = formatter.formatToParts(date);
  const month = parts.find((part) => part.type === 'month')?.value ?? '00';
  const day = parts.find((part) => part.type === 'day')?.value ?? '00';
  const year = parts.find((part) => part.type === 'year')?.value ?? '0000';
  const hour = parts.find((part) => part.type === 'hour')?.value ?? '00';
  const minute = parts.find((part) => part.type === 'minute')?.value ?? '00';
  const second = parts.find((part) => part.type === 'second')?.value ?? '00';
  const timeZone = parts.find((part) => part.type === 'timeZoneName')?.value ?? 'CDT';

  return `${month}-${day}-${year} ${hour}:${minute}:${second} ${timeZone}`;
}
